import React, { type ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import { Col } from "reactstrap";
import type { IntegrationShopify } from "src/integrations/objects/IntegrationShopify";
import { Showable } from "src/shared/components/Showable";
import { Formatter } from "src/shared/formatters/Formatter";

export interface IIntegrationDetailShopifyProps {
  integration: IntegrationShopify;
  children?: ReactNode;
}

export function IntegrationDetailShopify({
  integration,
  children,
}: IIntegrationDetailShopifyProps) {
  return (
    <>
      <Col sm={4} tag="dt">
        <FormattedMessage id="integrations.shopify.shop_domain" />
      </Col>
      <Col sm={8} tag="dd">
        <Formatter>{integration.shopDomain}</Formatter>
      </Col>

      <Col sm={4} tag="dt">
        <FormattedMessage id="integrations.shopify.api_key" />
      </Col>
      <Col sm={8} tag="dd">
        <Formatter value={integration.apiKey}>
          <code>{integration.apiKey}</code>
        </Formatter>
      </Col>

      {integration.accessToken && (
        <>
          <Col sm={4} tag="dt">
            <FormattedMessage id="integrations.shopify.accessToken" />
          </Col>
          <Col sm={8} tag="dd">
            <Showable>
              {(shown, button) => (
                <>
                  {shown && (
                    <Formatter value={integration.accessToken}>
                      <code>{integration.accessToken}</code>
                    </Formatter>
                  )}
                  {shown && <span className="ml-2" />}
                  {button}
                </>
              )}
            </Showable>
          </Col>
        </>
      )}

      <Col sm={4} tag="dt">
        <FormattedMessage id="integrations.shopify.apiSecret" />
      </Col>
      <Col sm={8} tag="dd">
        <Formatter value={integration.apiSecret}>
          <code>{integration.apiSecret}</code>
        </Formatter>
      </Col>

      {children}

      <Col sm={4} tag="dt">
        <FormattedMessage id="integrations.shopify.phone_label" />
      </Col>
      <Col sm={8} tag="dd">
        <Formatter>{integration.phoneLabel}</Formatter>
      </Col>
    </>
  );
}
